import gql from "graphql-tag";

import {gqlOp, type GqlOperation} from "@repo/data-gql-core";

type Data = {
    scheduleUserDeletion?: {
        error?: {
            code:
                | "INVALID_INPUT"
                | "UNAUTHORIZED"
                | "INTERNAL"
                | "IS_DISTRICT_SYNCED";
        };
    };
};

type Variables = {
    targetKaid: string;
    keepActivityIfNecessary?: boolean | null | undefined;
};

export const SCHEDULE_USER_DELETION_MUTATION: GqlOperation<Data, Variables> =
    gqlOp(gql`
        mutation scheduleUserDeletionMutation(
            $targetKaid: String!
            $keepActivityIfNecessary: Boolean
        ) {
            scheduleUserDeletion(
                targetKaid: $targetKaid
                keepActivityIfNecessary: $keepActivityIfNecessary
            ) {
                error {
                    code
                }
            }
        }
    `);
